const Domain = "https://well-one.in/Api";
// const Domain = "https://rahulharidas.online/api";
export { Domain };
// http://rahulrajrahu33.pythonanywhere.com/
// https://www.marygiricollegebackend.xyz
